"use client";

import { RichText } from "@/components/richText/richText.component";

import { VideoSection as VideoSectionType } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const VideoSection = ({ block }: VideoSectionProps) => {
  const videoUrl = (block.videoMedia.asset as { url?: string | null }).url;
  const posterUrl = block.thumbnail?.asset
    ? urlFor(block.thumbnail).width(1600).url()
    : undefined;

  if (!block?.headerContent?.length && !videoUrl) {
    return null;
  }

  return (
    <section
      data-testid="video-section"
      className="text-greyscale-body flex w-full flex-col gap-8 bg-white">
      <div className="mx-auto flex w-full flex-col items-center gap-10 pt-12 text-center">
        {block.headerContent?.length ? (
          <div className="flex w-full max-w-4xl flex-col gap-4 px-2">
            <RichText>{block.headerContent}</RichText>
          </div>
        ) : null}
        {videoUrl ? (
          <div className="relative w-full overflow-hidden bg-black shadow-lg">
            <video
              className="aspect-video w-full object-contain"
              controls
              playsInline
              preload="metadata"
              src={videoUrl}
              poster={posterUrl}
              aria-label={block.thumbnail?.alt || undefined}
              autoPlay={block?.autoplay}
              muted={true}
            />
          </div>
        ) : null}
      </div>
    </section>
  );
};

type VideoSectionProps = {
  block: VideoSectionType;
};
